<nav class="navbar " role="navigation">
  <div class="container">
    <div class="navbar-header">
      <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <div class="business-logo-align">
        <img class="white-logo" style="padding-top:1px;" cdnLink="true" imgSrc="/flpi/logo/logo-white.png" height="55" width="auto" />
      </div>
    </div>

    <div class="navbar-collapse collapse">
      <ul class="nav navbar-nav navbar-right">
        <li class="language-section">
          <country-language-selector></country-language-selector>
        </li>
        <li class="text-center">
          <div class="help-section">
            <div class="cart-section pull-right">
              <ul (mouseover)="showOrHideMyAccount(true)" (mouseleave)="showOrHideMyAccount(false)" class="nav navbar-nav navbar-right login-cart-dp pull-right">
                <li id="login-menu" class="dropdown login-menu transparent-bg col-xs-12 col-md-12 col-sm-6">
                  <div class="text-center">
                    <i class="fa fa-user-circle-o "></i>
                  </div>
                  <a href="javascript:void(0)" class="dropdown-toggle " data-toggle="dropdown" aria-expanded="false">
                    <span class="hidden-xs welcome-text word-wrap-user-name " title="{{firstName}} {{lastName}}">
                      <span class="user">{{firstName}} {{lastName}}</span>
                    </span>
                    <div class="text-center">
                      <i class="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                    </div>
                  </a>

                  <ul class="dropdown-menu no-padding">
                    <!-- <li>
                      <a href="javascript:void(0)" (click)="navigateToAccountSettings()">{{'header.Account Settings' | translate}}
                        <span class="glyphicon glyphicon-cog pull-right"></span>
                      </a>
                    </li>-->
                    <li class="divider"></li> 
                    <li>
                      <a href="javascript:void(0)" (click)="logout()">{{'header.Sign Out' | translate}}
                        <span class="glyphicon glyphicon-log-out pull-right"></span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
      <app-main-menu-bar></app-main-menu-bar>
    </div>
  </div>
</nav>
<div class="hide-print">
  <simple-notifications [options]="notificationsOptions"></simple-notifications>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/templates/template1/views/app-header.component.html